import { userLogin, userLogout, userLoginVerify } from "../constants/apiRoutes";
import { securityActions } from "../reducers/security";
import apiService from "../utils/configAxios";

import jwtDecode from "jwt-decode";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const login = (loginRequest) => {
  return (dispatch) => {
    return apiService
      .post(userLogin(), loginRequest)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        let errorMessage = err.response ? err.response.data.message : err;
        if (!err.response) {
          toast.error(
            "Greška, pokušajte da osvežite stranu pa ponovo pokušajte istu akciju.",
            { theme: "colored" }
          );
        }
        toast.error(errorMessage, { theme: "colored" });

        throw err;
      });
  };
};

export const loginVrify = (item, navigate) => {
  return (dispatch) => {
    return apiService
      .post(userLoginVerify(), item)
      .then((response) => {
        localStorage.setItem("token_value", response.data.token);
        localStorage.setItem("loggedUser", JSON.stringify(response.data));
        dispatch(securityActions.setCurrentUser(response.data));
        navigate("/dashboard");
      })
      .catch((err) => {
        let errorMessage = err.response ? err.response.data.message : err;
        if (!err.response) {
          toast.error(
            "Greška, pokušajte da osvežite stranu pa ponovo pokušajte istu akciju.",
            { theme: "colored" }
          );
        }
        toast.error(errorMessage, { theme: "colored" });

        throw err;
      });
  };
};

export const logout = (navigate) => {
  return (dispatch) => {
    localStorage.removeItem("token_value");
    localStorage.removeItem("loggedUser");
    dispatch(securityActions.setCurrentUser({}));
    navigate("/");
    /*return apiService
      .post(userLogout())
      .then((response) => {
        localStorage.removeItem("token_value");
        localStorage.removeItem("loggedUser");
        dispatch(securityActions.setCurrentUser({}));
        navigate("/");
      })
      .catch((err) => {
        let errorMessage = err.response ? err.response.data.message : err;
        if (!err.response) {
          toast.error(
            "Greška, pokušajte da osvežite stranu pa ponovo pokušajte istu akciju.",
            { theme: "colored" }
          );
        }
        toast.error(errorMessage, { theme: "colored" });
      });*/
  };
};
